<template>
	<div>
		<div ref="statsFilter" class="static">
      <div class="bg-zt-bg-main-td border-b border-b-zt-light xl:border-b-0 xl:!shadow-none">
        <FootballStatsFilter v-if="!reloadSwiper" class="bg-zt-light/35 pt-2.5 border-t border-x border-zt-light rounded-t-zt"
                             analytic-type="team" :is-league-results="true" :options="filteringOptions" :showHomeAway="true"
                             @filtering-changed="(value) => changeFilters(value)"/>
      </div>
		</div>
		<Transition name="fade" mode="out-in">
			<div key="0" v-if="loading" class="border-x border-zt-light border-t">
				<div v-for="i in startAmount" class="border-b border-zt-light bg-zt-light/35 w-full h-[51px] flex items-center p-2">
					<div class="bg-zt-more w-[150px] opacity-10 rounded-zt h-3"></div>
				</div>
				<div class="border-b border-zt-light justify-center bg-zt-light/35 w-full h-[49px] flex items-center p-2">
					<div class="bg-zt-more w-[150px] opacity-10 rounded-zt h-3"></div>
				</div>
			</div>
			<div key="1" v-else>
				<div class="border-t border-zt-light">
					<div v-if="!loading" v-for="(value, key, index) in roundsToShow" :key="key"
					     :class="{ '!border-b-0': index === Object.keys(roundsToShow).length - 1 }"
					     class="flex flex-col items-start w-full">
						<div v-for="(match, mIndex) in value.round_matches" :key="match.match_id" class="w-full">
              <FootballStatsListItem :team-id="teamId" :mark-winner="markWinner" :current-filters="selectedFilters"
                                     :displaying-stat="displayingStat"
                                     :filtering-result="calculateFilterResult(match)"
                                     :match="match"
                                     :show-teams-bg="['1x2', 'odds'].includes(selectedFilters[0]) ? [teamId] : []"
                                     :class="{ '!rounded-b-zt': index === Object.keys(roundsToShow).length - 1 && noOfMatches <= amount && !(hasPreviousYear && noOfMatches < amount)
							                        && mIndex === value.round_matches.length - 1 }"
                                     :redirect-to-h2h="match.is_h2h_available"
                                     :short-league-name="getLeagueShortName(match)"
                                     show-date show-animation :show-appear-animation="showAppearAnimation"
                                     :show-promotion-icon="isMatchRoundInPlayOffs(key)"
                                     :showOnlyInProgress="selectedFilters[0] !== '1x2' && !checkStatus(match.status)"
                                     :show-odds="selectedFilters[0] === 'odds' && hasOdds"
                                     :show-hour="shouldShowHour(match)"/>
						</div>
					</div>
				</div>
        <div v-if="Object.keys(roundsToShow).length === 0" class="h-[50px] text-xs grid place-items-center bg-zt-light/35
         text-zt-more border-x border-b border-zt-light" :class="{'rounded-b-zt' : !hasPreviousYear}">
          Brak meczów do wyświetlania
        </div>
				<div v-if="noOfMatches > amount" class="py-4 flex items-center rounded-b-zt h-[50px] border-b bg-zt-light/35 border-x
				 border-zt-light justify-center text-zt-more text-xs underline font-normal uppercase">
					<span class="cursor-pointer zt-hover"
                @click="showAppearAnimation = false; amount += loadNo; countClicks(expandAnalytics)">
            Rozwiń
          </span>
				</div>
        <div v-if="hasPreviousYear && noOfMatches <= amount" class="h-[50px] text-xs grid place-items-center bg-zt-light/35
         text-zt-more border-x border-zt-light" :class="{'!rounded-b-zt !border-b' : !showLastSeason}">
            <span class="cursor-pointer underline zt-hover" @click="showLastSeason = !showLastSeason">
              {{showLastSeason ? 'ZWIŃ POPRZEDNI SEZON' : 'ROZWIŃ POPRZEDNI SEZON'}}
              <svg class="transition inline-block ml-1" :class="{ 'rotate-180' : showLastSeason }" xmlns="http://www.w3.org/2000/svg" width="11" height="6" viewBox="0 0 11 6" fill="none">
                <path d="M1.1972 0L5.09444 3.24417L8.9917 2.98023e-07L10.1889 0.998746L5.09444 5.24875L0 0.998746L1.1972 0Z" fill="#93A3BA"/>
			        </svg>
            </span>
        </div>
        <Transition name="fade" mode="out-in">
          <div v-if="showLastSeason" class="border-t border-zt-light">
            <div v-if="!loading" v-for="(value, key, index) in lastSeasonMatchesToShow" :key="key"
                 class="flex flex-col items-start w-full">
              <div v-for="match in value.round_matches" :key="match.match_id" class="w-full">
                <FootballStatsListItem :team-id="teamId" :mark-winner="markWinner" :current-filters="selectedFilters"
                                       :displaying-stat="displayingStat"
                                       :filtering-result="calculateFilterResult(match)"
                                       :match="match"
                                       :show-teams-bg="['1x2', 'odds'].includes(selectedFilters[0]) ? [teamId] : []"
                                       :class="{ '!rounded-b-zt': index === Object.keys(lastSeasonMatchesToShow).length - 1 }"
                                       :redirect-to-h2h="match.is_h2h_available"
                                       :short-league-name="+match.league_id === 34 ? 'eMŚ' : ''"
                                       show-date show-animation :show-appear-animation="showAppearAnimation"
                                       :show-promotion-icon="isMatchRoundInPlayOffs(key)"
                                       :showOnlyInProgress="selectedFilters[0] !== '1x2' && !checkStatus(match.status)"
                                       :show-odds="selectedFilters[0] === 'odds' && hasOdds"
                                       :show-hour="shouldShowHour(match)"/>
              </div>
            </div>
            <div v-if="noOfLastSeasonMatches > Object.values(lastSeasonMatchesToShow).length"
                 class="py-4 flex items-center rounded-b-zt border-b bg-zt-light/35 border-x
                 border-zt-light justify-center text-zt-more text-xs underline font-normal uppercase">
              <span class="cursor-pointer zt-hover" @click="showAppearAnimation = false; showLastSeasonCount = noOfLastSeasonMatches">Rozwiń Pozostałe</span>
            </div>
          </div>
        </Transition>
			</div>
		</Transition>
	</div>
</template>

<script>
import FootballStatsFilter from "../../FootballStatsFilter.vue";
import utils_mixin from "../../../mixins/utils_mixin";
import football_mixin from "../../../mixins/football_mixin";
import FootballStatsListItem from "../../blocks/FootballStatsListItem.vue";
import sticky_filtering_mixin from '../../../mixins/sticky_filtering_mixin';

export default {
	name: 'TeamResultsTable',
	components: {FootballStatsListItem, FootballStatsFilter },
	mixins: [utils_mixin, football_mixin],
	inject: ['WP'],
  props: {
    teamId: {
			type: Number,
      required: true
		},
		leagueName: {
			type: String
		},
		countryName: {
			type: String
		},
    countryPolishQueryName: {
			type: String
		},
    teamResults: {
      type: Array,
      default: []
    },
	  rounds: {
			type: Object,
	  },
	  odds: {
			type: Boolean,
			default: true,
	  },
	  startAmount: {
			type: Number,
		  default: 15
	  },
	  loadNo: {
			type: Number,
		  default: 10
	  },
    expandAnalytics: {
      type: String,
      default: ''
    }
  },
	data() {
		return {
			selectedFilters: [],
			filteringOptions: [
				{
					name: '1x2',
					value: '1x2',
					options: []
				},
        {
          name: 'Kursy',
          value: 'odds',
          options: []
        },
				{
					name: 'Rożne',
					value: 'corners',
					options: [
						{
							name: 'Rezultat',
							value: 'result',
							options: []
						},
						{
							name: 'Over/Under',
							value: 'overunder',
							options: [
								{
									name: '7,5',
									value: 7.5,
									options: []
								},
								{
									name: '8,5',
									value: 8.5,
									options: []
								},
								{
									name: '9,5',
									value: 9.5,
									options: []
								},
								{
									name: '10,5',
									value: 10.5,
									options: []
								},
								{
									name: '11,5',
									value: 11.5,
									options: []
								},
								{
									name: '12,5',
									value: 12.5,
									options: []
								},
                {
                  name: 'All',
                  value: 'all',
                  analytic: {
                    text: 'Linie overów rożnych oraz kartek - ALL',
                    category: 'football'
                  },
                  options: []
                },
							]
						}
					]
				},
				{
					name: 'Kartki',
					value: 'cards',
					options: [
						{
							name: 'Żółte',
							value: 'yellowcards',
							options: [
								{
									name: 'Rezultat',
									value: 'result',
									options: []
								},
								{
									name: 'Over/Under',
									value: 'overunder',
									options: [
										{
											name: '1,5',
											value: 1.5,
											options: []
										},
										{
											name: '2,5',
											value: 2.5,
											options: []
										},
										{
											name: '3,5',
											value: 3.5,
											options: []
										},
										{
											name: '4,5',
											value: 4.5,
											options: []
										},
										{
											name: '5,5',
											value: 5.5,
											options: []
										},
                    {
                      name: 'All',
                      value: 'all',
                      analytic: {
                        text: 'Linie overów rożnych oraz kartek - ALL',
                        category: 'football'
                      },
                      options: []
                    },
									]
								}
							]
						},
            {
              name: 'Czerwone',
              value: 'redcards',
              options: [
                {
                  name: 'Rezultat',
                  value: 'result',
                  options: []
                },
                {
                  name: 'Over/Under',
                  value: 'overunder',
                  options: [
                    {
                      name: '0,5',
                      value: 0.5,
                      options: []
                    },
                  ]
                }
              ]
            }
					]
				},
				{
					name: 'BTTS',
					value: 'btts',
					options: []
				},
				{
					name: 'Over/under',
					value: 'overunder',
					options: [
						{
							name: '0,5',
							value: 0.5,
							options: []
						},
						{
							name: '1,5',
							value: 1.5,
							options: []
						},
						{
							name: '2,5',
							value: 2.5,
							options: []
						},
						{
							name: '3,5',
							value: 3.5,
							options: []
						},
						{
							name: '4,5',
							value: 4.5,
							options: []
						},
						{
							name: '5,5',
							value: 5.5,
							options: []
						},
            {
              name: 'All',
              value: 'all',
              analytic: {
                text: 'Linie overów rożnych oraz kartek - ALL',
                category: 'football'
              },
              options: []
            },
					]
				},
				{
					name: 'Połowy',
					value: 'halfs',
					options: [
						{
							name: '1. Połowa',
							value: 'firsthalf',
							options: []
						},
						{
							name: '2. Połowa',
							value: 'secondhalf',
							options: []
						},
					]
				},
				{
					name: 'Karne',
					value: 'penalty',
					options: [
						{
							name: 'Gole Z Karnych - Mecz',
							value: 'inmatch',
							options: []
						},
						{
							name: 'Gole Drużyna',
							value: 'for',
							options: []
						},
						{
							name: 'Gole Przeciwko',
							value: 'against',
							options: []
						},
					]
				},
			],
			amount: this.startAmount,
			loadAmount: this.loadNo,
			loading: false,
      reloadSwiper: false,
      hasPreviousYear: false,
      lastSeasonResults: [],
      showLastSeason: false,
      showLastSeasonCount: 5,
			showAppearAnimation: false,
			filteringChangedNo: 0,
		}
	},
  computed: {
		lastSeasonMatchesToShow() {
			return Object.fromEntries(Object.entries(this.filteredLastSeasonRounds).slice(0, this.showLastSeasonCount));
		},
    roundsToShow() {
      if (this.rounds) {
        let tempRounds = [];
        let displayedMatchesCount = 0;
        let rounds = Object.entries(this.filteredRounds).slice(0, this.amount);
        rounds.forEach((round) => {
          if (round[1].round_matches.length + displayedMatchesCount <= this.amount) {
            tempRounds.push(round);
            displayedMatchesCount += round[1].round_matches.length;
          } else if (displayedMatchesCount < this.amount) {
            tempRounds.push([round[0], {
              round_matches : round[1].round_matches.slice(0, this.amount - displayedMatchesCount)
            }]);
            displayedMatchesCount += this.amount - displayedMatchesCount;
          }
        })
        return Object.fromEntries(tempRounds);
      }
      return {};
    },
    markWinner() {
      return !(this.selectedFilters[0] !== '1x2' && this.selectedFilters[0] !== 'odds');
    },
    noOfMatches() {
      if (this.filteredRounds) {
        let rounds = Object.values(this.filteredRounds);
        return  rounds.reduce((acc, round) => acc + round.round_matches.length, 0);
      }
      return 0;
    },
    noOfLastSeasonMatches() {
      if (this.filteredLastSeasonRounds) {
        let rounds = Object.values(this.filteredLastSeasonRounds);
        return  rounds.reduce((acc, round) => acc + round.round_matches.length, 0);
      }
      return 0;
    },
    displayingStat() {
      if (this.selectedFilters[0] === 'corners') {
        return 'corners';
      }
      if (this.selectedFilters[0] === 'penalty') {
        return 'penalty';
      }
      if (this.selectedFilters[0] === 'cards') {
        return 'cards';
      }
      if (this.selectedFilters[0] === 'halfs') {
        return this.selectedFilters[1] === 'firsthalf' ? 'firsthalf' : 'secondhalf'
      }
      if (this.selectedFilters[0] === 'btts' || this.selectedFilters[0] === 'overunder' ) {
        return 'ft_goals'
      }
      return 'goals';
    },
    hasOdds() {
      if (this.rounds) {
        return Object.values(this.rounds).some((round) => {
          return round.round_matches.some(match => {
            return match.odds !== null;
          })
        });
      }
      return false;
    },
    countryFlag() {
      return `/wp-content/themes/zawodtyper/assets/images/kraje/${this.countryPolishQueryName.toLowerCase()}.svg`;
    },
    filteredRounds() {
			return this.filterRounds(this.rounds);
    },
    filteredLastSeasonRounds() {
      return this.filterRounds(this.lastSeasonResults);
    }
  },
	mounted() {
    this.getTeamMatches();
    if (webSocketsEnabled) {
      this.addWSListeners();
    }
    if (!this.hasOdds) {
      let index = this.filteringOptions.findIndex(option => option.name === 'Kursy');
      this.filteringOptions.splice(index, 1);
      this.reloadSwiper = true;
      setTimeout(()=> {this.reloadSwiper = false}, 100);
    }
    this.getPreviousSeason();
	},
	watch: {
		selectedFilters(newVal, oldVal) {
			if (this.filteringChangedNo <= 1) {
				return;
			}
			this.showAppearAnimation = true;
		}
	},
	methods: {
    shouldShowHour(match) {
      // const isTournament = this.leagueType === 'European Cup' || this.leagueType === 'National Cup';

      const matchDate = DateTime.fromSQL(match.date).startOf('day');
      const today = DateTime.now().startOf('day');
      return today.diff(matchDate, 'days').days <= 1 && today.diff(matchDate, 'days').days >= -1;
    },
    getLeagueShortName(match) {
      const leagues = {
        34: 'eMŚ',
        32: 'eMŚ',
        9: 'CA',
        10: 'Tow.',
        5: 'LN',
        960: 'eME',
        4: 'EURO'
      }
      return leagues[match.league_id] ?? '';
    },
		filterRounds(rounds) {
			rounds = Object.entries(rounds);
			if (rounds) {
				if (this.selectedFilters[this.selectedFilters.length - 1] !== 'all') {
					let filteredRounds = [];
					if (this.selectedFilters[this.selectedFilters.length - 1] === 'home') {
						rounds.forEach((round) => {
							let filteredMatches = round[1].round_matches.filter(match => { return +match.localteam_id === +this.WP.team.team_id })
							if (filteredMatches.length > 0) {
								filteredRounds.push([round[0], {round_matches : filteredMatches}]);
							}
						})
					} else if (this.selectedFilters[this.selectedFilters.length - 1] === 'away') {
						rounds.forEach((round) => {
							let filteredMatches = round[1].round_matches.filter(match => { return +match.visitorteam_id === +this.WP.team.team_id })
							if (filteredMatches.length > 0) {
								filteredRounds.push([round[0], {round_matches : filteredMatches}]);
							}
						})
					}
					return Object.fromEntries(filteredRounds);
				} else {
					return Object.fromEntries(rounds);
				}
			}
			return [];
		},
		changeFilters(value) {
			this.selectedFilters = value;
			this.filteringChangedNo++;
		},
		calculateFilterResult(match) {
			if (this.selectedFilters[0] === '1x2') {
					const matchResult = +match.localteam_id === this.teamId ? +match.localteam_goals - +match.visitorteam_goals : +match.visitorteam_goals - +match.localteam_goals;
          if (matchResult === 0 && (match.localteam_penalty_shootout > 0 || match.visitorteam_penalty_shootout > 0)) {
            if (+match.localteam_id === this.teamId) {
              return match.localteam_penalty_shootout > match.visitorteam_penalty_shootout ? 'W' : 'P';
            } else {
              return match.visitorteam_penalty_shootout > match.localteam_penalty_shootout  ? 'W' : 'P';
            }
          }
		  		return matchResult > 0 ? 'W' : matchResult === 0 ? 'R' : 'P';
			}
			if (this.selectedFilters[0] === 'overunder') {
				const value = this.selectedFilters[1];
				const matchGoals = +match.localteam_goals + +match.visitorteam_goals - +match.localteam_et_goals - +match.visitorteam_et_goals;
				return matchGoals > value ? 'W' : 'P';
			}
			if (this.selectedFilters[0] === 'btts') {
				return +match.localteam_goals - +match.localteam_et_goals > 0 && +match.visitorteam_goals - +match.visitorteam_et_goals > 0 ? 'W' : 'P';
			}
			if (this.selectedFilters[0] === 'corners') {
				if (this.selectedFilters[1] === 'overunder') {
					const value = this.selectedFilters[2];
					const matchCorners = +match.localteam_corners + +match.visitorteam_corners;
					return matchCorners > value ? 'W' : 'P';
				} else {
					const matchCorners = +match.localteam_id === this.teamId ? +match.localteam_corners - +match.visitorteam_corners : +match.visitorteam_corners - +match.localteam_corners;
					return matchCorners > 0 ? 'W' : matchCorners === 0 ? 'R' : 'P';
				}
			}
			if (this.selectedFilters[0] === 'cards') {
        let match_index = this.teamResults.findIndex(el => {
          return el.match_id === match.match_id;
        })
        if (this.selectedFilters[1] === 'yellowcards') {
          if (this.selectedFilters[2] === 'overunder') {
            const value = this.selectedFilters[3];
            const matchCards = match_index === -1 ? +match.localteam_yellowcards + +match.visitorteam_yellowcards :
                this.teamResults[match_index]['cards_stats'].yellow.team + this.teamResults[match_index]['cards_stats'].yellow.opponent;
            return matchCards > value ? 'W' : 'P';
          } else {
            const matchCards =  +match.localteam_id === this.teamId ?
                match_index === -1 ? +match.visitorteam_yellowcards - +match.localteam_yellowcards : this.teamResults[match_index]['cards_stats'].yellow.team - this.teamResults[match_index]['cards_stats'].yellow.opponent :
                match_index === -1 ? +match.localteam_yellowcards - +match.visitorteam_yellowcards : this.teamResults[match_index]['cards_stats'].yellow.opponent - this.teamResults[match_index]['cards_stats'].yellow.team;
            return matchCards < 0 ? 'W' : matchCards === 0 ? 'R' : 'P';
          }
        } else {
          if (this.selectedFilters[2] === 'overunder') {
            const value = this.selectedFilters[3];
            const matchCards = match_index === -1 ? +match.localteam_red_cards + +match.visitorteam_red_cards :
                this.teamResults[match_index]['cards_stats'].red.team + this.teamResults[match_index]['cards_stats'].red.opponent;
            return matchCards > value ? 'W' : 'P';
          } else {
            const matchCards =  +match.localteam_id === this.teamId ?
                match_index === -1 ? +match.visitorteam_red_cards - +match.localteam_red_cards : this.teamResults[match_index]['cards_stats'].red.team - this.teamResults[match_index]['cards_stats'].red.opponent :
                match_index === -1 ? +match.localteam_red_cards - +match.visitorteam_red_cards : this.teamResults[match_index]['cards_stats'].red.opponent - this.teamResults[match_index]['cards_stats'].red.team;
            return matchCards < 0 ? 'W' : matchCards === 0 ? 'R' : 'P';
          }
        }
			}
			if (this.selectedFilters[0] === 'halfs') {
				if (this.selectedFilters[1] === 'firsthalf') {
					const matchHalf =  +match.localteam_id === this.teamId ? +match.localteam_ht_goals - +match.visitorteam_ht_goals : +match.visitorteam_ht_goals - +match.localteam_ht_goals;
					return matchHalf > 0 ? 'W' : matchHalf === 0 ? 'R' : 'P';
				} else {
					const matchHalf =  +match.localteam_id === this.teamId ? (+match.localteam_goals - +match.localteam_ht_goals - +match.localteam_et_goals) -
              (+match.visitorteam_goals - +match.visitorteam_ht_goals - +match.visitorteam_et_goals) :
              (+match.visitorteam_goals - +match.visitorteam_ht_goals - +match.visitorteam_et_goals) -
              (+match.localteam_goals - +match.localteam_ht_goals - +match.localteam_et_goals);
					return matchHalf > 0 ? 'W' : matchHalf === 0 ? 'R' : 'P';
				}
			}
			if (this.selectedFilters[0] === 'penalty') {
				if (this.selectedFilters[1] === 'for') {
					if (+match.localteam_id === this.teamId) {
						return +match.localteam_penalties > 0 ? 'W' : 'P';
					} else {
						return +match.visitorteam_penalties > 0 ? 'W' : 'P';
					}
				} else if ( this.selectedFilters[1] === 'against' ) {
					if (+match.localteam_id === this.teamId) {
						return +match.visitorteam_penalties > 0 ? 'W' : 'P';
					} else {
						return +match.localteam_penalties > 0 ? 'W' : 'P';
					}
				}
				return +match.localteam_penalties > 0 || +match.visitorteam_penalties > 0 ? 'W' : 'P';
			}
		},
    addWSListeners() {
      socket?.on('live-matches', data => {
        let flattenedRounds = Object.values(this.rounds).map(el => {
          return el.round_matches;
        });
        data.forEach(match => {
          flattenedRounds.forEach(round => {
            let index = round.findIndex(el => {
              return Number(el.match_id) === Number(match.match_id);
            });
            if (index !== -1) {
              if (match.status === 'FT') {
                this.getTeamMatches();
              } else {
                round[index].visitorteam_visitor_cards = match.visitorteam_visitor_cards;
                round[index].localteam_goals = match.localteam_goals;
                round[index].visitorteam_goals = match.visitorteam_goals;
                round[index].elapsed = match.elapsed;
                round[index].status = match.status;
                round[index].localteam_red_cards = match.localteam_red_cards;
              }
            }
          })
        })
      });
    },
    getTeamMatches() {
      if (this.rounds) {
        if(Object.values(this.rounds).some((round) => {
          let corners = 0;
          round.round_matches.forEach((match) => {
            corners += Number(match.localteam_corners) + Number(match.visitorteam_corners);
          })
          return corners === 0;
        })) {
          let index = this.filteringOptions.findIndex(el => {
            return el.name === 'Rożne';
          })
          if (index !== -1) {
            this.filteringOptions.splice(index, 1);
          }
        }
      }
    },
    getPreviousSeason() {
      const resRound = axios.post(this.WP.ajaxUrl, {
        endpoint: 'api_get_team_results',
        team_id: this.WP.team.team_id,
        previous_season: true
      }).then(resp =>  {
        this.lastSeasonResults = resp.data.data;
        if (Object.values(this.lastSeasonResults).length > 0) {
          this.hasPreviousYear = true;
        }
      });
    }
	},
}
</script>
<style scoped>
.fade-enter-active,
.fade-leave-active {
	z-index: 10;
	transition: all 0.3s ease-out;
}

.fade-enter-from,
.fade-leave-to {
	z-index: 10;
	opacity: 0;
}
</style>